import { render, staticRenderFns } from "./MtfQuestion.vue?vue&type=template&id=a966c22a&scoped=true&"
import script from "./MtfQuestion.vue?vue&type=script&lang=js&"
export * from "./MtfQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MtfQuestion.vue?vue&type=style&index=0&id=a966c22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a966c22a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VIcon,VRow,VSubheader})
